module.exports = __webpack_public_path__ + "img/sld_mfm_ic_2_b1_dark.2f2bdcec.svg";